import React, { useState } from "react";
import {
	Modal,
	Button
} from "rhombus-react";

import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import { reset } from "redux-form";

import useActiveCreative from "hooks/useActiveCreative";
import useCreativeDetail from "hooks/useCreativeDetail";

import ProgressContainer from "widgets/ProgressContainer";
import CreativePreviewBladeToolbar from "widgets/modals/creatives/preview/CreativePreviewBladeToolbar";
import { isLegacyPreview, PreviewCreative, LegacyPreviewCreative } from "utils/Preview";
import { LABEL_MANAGEMENT } from "widgets/forms/list";
import LabelsPanel from "widgets/modals/creatives/preview/LabelsPanel";

import CreativePreview from "./CreativePreview";

import "./CreativePreviewBlade.css";

export default function CreativePreviewBlade(props){
	let { returnPath, libraryId, creativeId } = props
		,  dispatch = useDispatch()
		, [isFullScreen, setIsFullScreen] = useState(false)
		, [isPreviewLoaded, setIsPreviewLoaded] = useState(false)
		, [randomKey, setRandomKey] = useState(0)
		;

	const creative = useSelector(state => state.creativeDetails);
	const {
		filename,
		width,
		height,
		adType,
		origin,
		isLoaded,
	} = useSelector(state => state.creativeDetails);
	const isLegacy = isLegacyPreview(creative);
	const title = filename ? filename : " ";

	useActiveCreative(creativeId);

	creativeId = parseInt(creativeId);
	const previewURL = isLegacy ? LegacyPreviewCreative.private(creativeId) : PreviewCreative.private(creativeId);

	useCreativeDetail(creativeId);

	function closeModal(){
		dispatch(reset(LABEL_MANAGEMENT)); /*
			We don't destroy the label management form on unmount, so we have to reset it manually
			when the blade closes.
		*/
		dispatch(push(returnPath));
	}

	function onToggleFullScreen(){
		setIsFullScreen(!isFullScreen);
	}

	function onReplay(){
		setRandomKey(randomKey + 1);
	}

	function Footer(){
		return [
			<Button
				key="close"
				theme="default"
				onClick={closeModal}
				className="close-btn"
			>
				Close
			</Button>,
		];
	}

	function Content(){
		return (
			<div className="main-content-container">
				<ProgressContainer isLoading={!isLoaded || !isPreviewLoaded}>
					<CreativePreview
						key={randomKey}
						keyId={randomKey}	//We set a key here in order for the `replay()` functionality to work and force a re-render
						width={width}
						height={height}
						creativeId={creativeId}
						adType={adType}
						origin={origin}
						onLoad={() => { setIsPreviewLoaded(true); }}
					/>
				</ProgressContainer>
				<LabelsPanel
					libraryId={libraryId}
					creativeId={creativeId}
				/>
				<CreativePreviewBladeToolbar
					isFullScreen
					onReplay={onReplay}
					previewURL={previewURL}
				/>
			</div>
		);
	}

	let modalProps = {
		title,
		type: "blade",
		className: "creative-preview-blade expandable",
		setAppTitle:false,

		xClose: true,
		allowFullScreen: true,
		isFullScreen,
		onToggleFullScreen,

		renderFooter: Footer,
		renderContent: Content,

		onClose: closeModal,
	};

	return <Modal {...modalProps} />;
}

CreativePreviewBlade.defaultProps = {
	returnPath:"",
	libraryId:-1,
	creativeId:-1,
};
